/**
 * ImpersonationBanner — sticky warning bar shown when admin is viewing as another user.
 */

import { useTranslation } from 'react-i18next';

import { useImpersonation } from '../../context/ImpersonationContext';
import SafeTrans from '../../i18n/SafeTrans';
import './ImpersonationBanner.css';

const EyeIcon = () => (
  <svg width="14" height="14" viewBox="0 0 16 16" fill="none" style={{ verticalAlign: 'middle', marginRight: 4 }}>
    <path d="M1 8s2.5-5 7-5 7 5 7 5-2.5 5-7 5-7-5-7-5z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" fill="none" />
    <circle cx="8" cy="8" r="2" stroke="currentColor" strokeWidth="2" fill="none" />
  </svg>
);

export default function ImpersonationBanner() {
  const { t } = useTranslation('shell');
  const { isImpersonating, targetAlias, exitImpersonation } = useImpersonation();

  if (!isImpersonating) return null;

  return (
    <div className="impersonation-banner">
      <span className="impersonation-banner__text">
        <EyeIcon />{' '}
        <SafeTrans
          t={t}
          i18nKey="impersonation.banner"
          values={{ alias: targetAlias }}
          components={{ strong: <strong /> }}
        />
      </span>
      <button
        className="impersonation-banner__exit"
        onClick={exitImpersonation}
        aria-label={t('impersonation.exitLabel')}
      >
        {t('impersonation.exit')}
      </button>
    </div>
  );
}
